import React from 'react';
import ReactMarkdown from 'react-markdown';
import CodeBlock from './CodeBlock';
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';
import RemarkMathPlugin from "remark-math";

// export default function Markdown(props) {
//     return (
//         <ReactMarkdown
//             source={props.source}
//             renderers={{
//                 code: CodeBlock,
//             }}
//         />
//     );
// }

// export default function Markdown(props) {
//     const newProps = {
//         ...props,
//         plugins: [RemarkMathPlugin],
//         renderers: {
//             ...props.renderers,
//             code: CodeBlock,
//             math: (props) => <MathJax.Node>{props.value}</MathJax.Node>,
//             inlineMath: (props) => <MathJax.Text text={props.value} />,
//         }
//     };

//     const options = {
//         asciimath2jax: {
//             useMathMLspacing: true,
//             delimiters: [["$$", "$$"], ["$", "$"]],
//             preview: "none",
//         }
//     }

//     return (
//         <MathJax.Context
//             onLoad={() => console.log("Loaded MathJax")}
//             onError={(MathJax, error) => {
//                 console.warn(error);
//                 console.log("Encountered a MathJax error, re-attempting a typeset!");
//                 MathJax.Hub.Queue(
//                     MathJax.Hub.Typeset()
//                 );
//             }}
//             script="https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=AM_HTMLorMML"
//             // script="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js?config=TeX-AMS-MML_HTMLorMML"
//             options={options}
//         >
//         <ReactMarkdown {...newProps} />
//         </MathJax.Context> 
//     );
// };

export default function Markdown(props) {
    const newProps = {
        ...props,
        plugins: [
            RemarkMathPlugin,
        ],
        renderers: {
            ...props.renderers,
            code: CodeBlock,
            math: (props) => <BlockMath math={props.value} />,
            inlineMath: (props) => <InlineMath math={props.value} />
        }
    };
    return (
        <ReactMarkdown escapeHtml={false} className="markdown" {...newProps} />
    );
};
